import React from 'react'
import type { DividerBlock as BlockProps } from '@/payload-types'
import { cn } from '@/utilities/cn'

const SPACING_CLASS: Record<string, string> = {
  none: 'my-0',
  sm: 'my-2',
  md: 'my-6',
  lg: 'my-12',
  xl: 'my-20',
}
const STYLE_CLASS: Record<string, string> = {
  solid: 'border-t border-slate-200',
  dashed: 'border-t border-dashed border-slate-300',
  dotted: 'border-t border-dotted border-slate-300',
  // Invisible = no rule, just the spacing — useful as a poor-man's gap
  // between adjacent blocks without nesting them in a Stack.
  invisible: '',
}

export const DividerBlock: React.FC<BlockProps> = ({ spacing, style }) => {
  return (
    <hr
      className={cn(
        'w-full',
        SPACING_CLASS[spacing || 'md'],
        STYLE_CLASS[style || 'solid'],
      )}
      aria-hidden={style === 'invisible' ? 'true' : undefined}
    />
  )
}
